export const PUBLIC_PAGES = {
  HOME: '/',
  NBN_PLANS: '/go/internet',
  MOBILE_PLANS: '/go/mobile',
  DATA_PLANS: '/go/data-plans',
  BLOG: '/go/blog',
  NBN_SERVICE_QUALIFICATION: '/go/internet/check-your-address',
  NBN_PLANS_SQ: '/go/internet?step=serviceability-details',
  SUSTAINABLITY: '/go/sustainability',
  SEARCH: '/go/search',
  ACTIVE_SIM: '/go/activate-sim',
  ESIM: '/go/esim',
  EXPLORE_MOBILE: '/go/explore-mobile-and-data',
  INTERNATIONAL_ROAMING: '/go/international-roaming',
  PAYMENT_ASSISTANCE: '/go/payment-assistance'
};
